import {
  FilterParams,
  PaginatedData,
  PaginatedParams
} from "src/library/utils";
import useAxios from "src/core/shared/hooks/useAxios";
import {
  EndpointConfig,
  RequestConfig,
  UseApiRequest
} from "src/core/shared/api/config.api";

import {
  IProcessJob,
  ProcessJobName,
  ProcessJobPayloads
} from "./processJobs.api";

export type GetScheduleParams = { filters?: FilterParams<IProcessJobSchedule>; pagination?: PaginatedParams<IProcessJobSchedule> };
export type UpdateScheduleParam = {awsScheduleParams: Partial<AwsScheduleParams>, processJobSchedule: Partial<IProcessJobSchedule>} & { processJobScheduleId: number };
type ProcessJobScheduleEndPointConfig = {
  GET_PROCESS_JOB_SCHEDULES: EndpointConfig<
    GetScheduleParams,
    PaginatedData<ICombinedJobSchedule>
  >;
  UPDATE_PROCESS_JOB_SCHEDULE: EndpointConfig<
  UpdateScheduleParam,
    IProcessJobSchedule
  >;
  CREATE_PROCESS_JOB_BY_SCHEDULE_ID: EndpointConfig<
  number,
  IProcessJob
  >;
};

const requests: RequestConfig<ProcessJobScheduleEndPointConfig> = {
  GET_PROCESS_JOB_SCHEDULES: params => ({
    url: `${process.env.REACT_APP_API_URL}/core/process-job-schedules`,
    method: "GET",
    params
  }),
  UPDATE_PROCESS_JOB_SCHEDULE: data => ({
    url: `${process.env.REACT_APP_API_URL}/core/process-job-schedules/${data.processJobScheduleId}`,
    method: "PATCH",
    data
  }),
  CREATE_PROCESS_JOB_BY_SCHEDULE_ID: (scheduleId: number) => ({
    url: `${process.env.REACT_APP_API_URL}/core/process-job-schedules/${scheduleId}/trigger`,
    method: "POST"
  })
};

export const useProcessJobsScheduleApi: UseApiRequest<ProcessJobScheduleEndPointConfig> = (name, config) => useAxios(requests[ name ], name, config);

export interface IProcessJobSchedule {
  id: number;
  createdAt: Date;
  updatedAt: Date;
  name: string;
  description: string;
  jobName: ProcessJobName;
  jobParams: ProcessJobPayloads;
  awsScheduleArn: string;
}
//parameters which come from AWS but are not synced in with mezze db
export interface AwsScheduleParams {
  //cron expression
  scheduleExpression?: string;
  state?: "ENABLED" | "DISABLED",
}

export type ICombinedJobSchedule = IProcessJobSchedule & AwsScheduleParams;
